module.exports = __webpack_public_path__ + "assets/T1_LineDetailed.a8bd5ce0140eed0d2d57b5eecb4ae7b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/T1_LineDetailed.png
// module id = 572
// module chunks = 0